/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React from 'react'
import Select, { type OptionProps, type StylesConfig } from 'react-select'
import Tooltip from '@mui/material/Tooltip'
import './GenXDropdown.css'

export interface Option {
  value: string
  label: string
  unit?: string
  isKPI?: boolean
  isAssetKPI?: boolean
  mDisabled?: boolean
  color?: string
  check?: boolean
}

const injectLabel = (label: string | undefined): JSX.Element => {
  return <span style={{ fontSize: '15px', paddingBottom: 10 }}>{label}</span>
}
export interface GenXDropdownProps {
  options: Option[]
  value: Option | Option[] | null
  onSelect: (selectedValue: Option, index?: number) => void
  placeholder?: string
  width?: number | string
  height?: number
  label?: string
  unit?: string
  mDisabled?: boolean
  inputId?: string
  disabled?: boolean
  onBlur?: () => void
  onFocus?: () => void
  error?: boolean
  isSearchable?: boolean
  menuPlacement?: 'auto' | 'bottom' | 'top'
}

const isColor = (color: string | undefined): boolean => {
  let option = new Option().style.color
  option = color ?? ''
  return option !== ''
}

export function GenXDropdown ({ options, onSelect, value, placeholder, width, label, unit, mDisabled, disabled, height, inputId, onBlur, onFocus, error, isSearchable = true, menuPlacement = 'bottom' }: GenXDropdownProps): JSX.Element {
  const customStyles: StylesConfig = {
    control: (provided: any, { isFocused }) => ({
      ...provided,
      border: error ? '1px solid #d32f2f' : isFocused ? '2px solid #64C3FF' : '1px solid #404040',
      borderRadius: '4px',
      boxShadow: 'none',
      backgroundColor: '#272727',
      width: width !== undefined ? width : 260,
      cursor: 'pointer',
      height: 40,
      minHeight: 40,
      color: '#ffffff',
      opacity: disabled ? '0.5' : '1',
      fontSize: '16px',
      fontWeight: '500'
    }),
    option: (styles: any, { isSelected, isFocused }) => ({
      ...styles,
      color: isSelected ? '#64C3FF' : '#f0f0f0',
      backgroundColor: (isSelected) ? '#1792E51A' : (isFocused) ? '#303030' : '#404040',
      width: width !== undefined ? width : 260,
      overflow: 'ellipses',
      padding: '5px 8px'
    }),
    menu: (provided: any) => ({
      ...provided,
      boxShadow: '0 0 10px rgba(73, 69, 69, 0.1)',
      width: width !== undefined ? width : 260,
      backgroundColor: '#404040',
      zIndex: '2'
    }),
    valueContainer: (styles: any) => ({
      ...styles,
      height: 40,
      paddingLeft: '8px'
    }),
    indicatorsContainer: (styles: any) => ({
      ...styles,
      height: 40,
      paddingRight: '4px'
    })
  }

  const handleChange = (selectedOption: Option, index?: number): void => {
    if (selectedOption != null) {
      onSelect(selectedOption, index)
    }
  }

  const customOption = (data: Option): React.ReactNode => {
    const color = isColor(data.color) ? data.color : 'transparent'
    if (data.color) {
      return (
        <div className='option-elm' style={{ display: 'flex', alignItems: 'center' }}>
          <div
            style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: color,
              marginRight: 10,
              marginLeft: 10
            }}
          />
          {data.label}
        </div>
      )
    } else if (data.check) {
      return (
        <div className='option-elm' style={{ display: 'flex', alignItems: 'center' }}>
          <input className='dropdown-chechbox' type="checkbox" checked={Array.isArray(value) ? value?.some((e) => e.label === data.label) : value?.label === data.label } name="" id="" />
          {data.label}
        </div>
      )
    } else {
      return (
        <div className='option-elm dropdown-text-ellipsis' style={{ paddingLeft: '8px', color: '#ffffff' }}>
          {data.label}
        </div>
      )
    }
  }

  return (
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    <div style={{ display: 'flex', flexDirection: 'column' }} id={inputId + '-genx-dropdown'} >
      {label !== undefined && injectLabel(label)}
      <Select
        menuPlacement={menuPlacement}
        defaultMenuIsOpen={false}
        value={Array.isArray(value) ? '' : value}
        options={options}
        errorText={true}
        err
        classNames={{
          option: (props) => {
            return (props.data !== null && props.data !== undefined && (props.data as { label?: string }).label !== undefined && (props.data as { label?: string }).label !== undefined) ? `${(props.data as { label?: string }).label}-option` : 'genx-dropdown-option'
          }
        }}
        isSearchable={isSearchable}
        onFocus={onFocus}
        onBlur={onBlur}
        required={true}
        className={'error'}
        isvalid
        aria-invalid={true}
        aria-errormessage={'afsd'}
        inputId={inputId ?? 'genx-dropdown'}
        maxMenuHeight={height !== undefined ? height : 150}
        noOptionsMessage={() => <p className='no-options'> No Options </p>}
        // @ts-expect-error - typescript is not able to determine the type
        onChange={handleChange}
        placeholder={placeholder !== undefined ? placeholder : 'Select an option'}
        unstyled
        styles={customStyles}
        isDisabled={!!disabled}
        components={{
          Option: ({ innerRef, innerProps, data }: OptionProps<any, false>) => (
            <Tooltip title={data.label.length > 25 ? data.label : ''} arrow>
              <div ref={innerRef} {...innerProps} className="dropdown-option">
                {customOption(data as Option)}
              </div>
            </Tooltip>
          )
        }}
        theme={(theme: any) => ({
          ...theme,
          borderRadius: 0,
          height: 40,
          colors: {
            ...theme.colors,
            primary25: 'hotpink',
            neutral0: '#404040'
          }
        })}
      />
    </div>
  )
}
